<script setup>
import { computed, inject } from 'vue';
import SubHead from '@/components/result/SubHead.vue';
import SubArea from '@/components/result/SubArea.vue';
import AnswerRates from '@/components/result/AnswerRates.vue';
import SubareaAnalysis from '@/components/result/SubareaAnalysis.vue'; 

import numeracyGraph02 from '@/assets/images/result/numeracy_graph_02.png';

// 부모에서 주입받은 데이터
const studentData = inject('studentData');
const loading = inject('loading');

const pagetype = "numeracy";
const region = "seoul";
const userRole = "student";

// API 데이터를 기반으로 한 computed 값들
const studentName = computed(() => {
    return studentData.value?.name || '로딩중...';
});

// 수리력 영역별 정답률 (mathsub1~4: 수와 양, 모양과 측정, 규칙과 관계, 자료와 불확실성)
const ourClassPercentages = computed(() => {
    if (!studentData.value) return [-1, -1, -1, -1];
    
    return [
        parseInt(studentData.value.matsub1_rate) || -1,  // 수와 양
        parseInt(studentData.value.matsub2_rate) || -1,  // 모양과 측정
        parseInt(studentData.value.matsub3_rate) || -1,  // 규칙과 관계
        parseInt(studentData.value.matsub4_rate) || -1   // 자료와 불확실성
    ];
});

// 전체 정답률 (mathsub1_total_rate~4)
const overallPercentages = computed(() => {
    if (!studentData.value) return [0, 0, 0, 0];
    
    return [
        parseInt(studentData.value.matsub1_total_rate) || 0,  // 수와 양
        parseInt(studentData.value.matsub2_total_rate) || 0,  // 모양과 측정
        parseInt(studentData.value.matsub3_total_rate) || 0,  // 규칙과 관계
        parseInt(studentData.value.matsub4_total_rate) || 0   // 자료와 불확실성
    ];
});

// 각 영역별 안전도 (안전, 경계, 주의)
const subAreaLevels = computed(() => {
    if (!studentData.value) return ['', '', '', ''];
    
    return [
        studentData.value.matsub1_level || '',  // 수와 양
        studentData.value.matsub2_level || '',  // 모양과 측정
        studentData.value.matsub3_level || '',  // 규칙과 관계
        studentData.value.matsub4_level || ''   // 자료와 불확실성
    ];
});

</script>

<template lang="">
    <div class="slide-inner">
        <div class="content">    
            <SubHead :type="pagetype" :region="region" :hideTitleBox="true" />
             <div class="card-wrap">
                <SubArea 
                    :type="pagetype" 
                    :region="region" 
                    :userRole="userRole" 
                    :isStudent="true"
                    :subAreaLevels="subAreaLevels"
                />
                <AnswerRates
                    :type="pagetype" 
                    :graph-src="literacyGraph02"
                    :our-class-percentages="ourClassPercentages"
                    :overall-percentages="overallPercentages"
                    :isStudent="true"
                    :userRole="userRole"
                />
                <SubareaAnalysis 
                    :type="pagetype"
                    :studentName="studentName"
                    :subAreaLevels="subAreaLevels"
                    :schoolType="studentData?.schul_type || 'E'"
                    :grade="parseInt(studentData?.grade_code) || 4"
                />
            </div>
        </div>
    </div>
</template>